import { useMemo, useState } from "react";

import { Hide, Show } from "@monta/icons";
import { ensuredForwardRef } from "../../../utils";
import InputWrapper, { filterInputWrapperProps } from "../InputWrapper/wrapper";
import styles from "./TextField.module.scss";

import type { InputHTMLAttributes, MutableRefObject } from "react";
import type { InputWrapperProps } from "../InputWrapper/types";

export type TextFieldProps = InputWrapperProps &
  InputHTMLAttributes<HTMLInputElement> & {
    wrapperClassName?: string;
    height?: number;
  };
const TextField = ensuredForwardRef<HTMLInputElement, TextFieldProps>(
  (props: TextFieldProps, ref) => {
    const { type = "text", wrapperClassName, id, placeholder, height } = props;
    const wrappedProps = filterInputWrapperProps(props);
    const InputWrapperProps = wrappedProps?.[0];

    const [showPassword, setShowPassword] = useState(false);

    const passwordInnerAfter = useMemo(
      () => (
        <div className={styles["show-password"]}>
          {showPassword ? (
            <Hide onClick={() => setShowPassword(false)} />
          ) : (
            <Show
              color="none"
              stroke="#000"
              onClick={() => setShowPassword(true)}
            />
          )}
        </div>
      ),
      [showPassword]
    );

    return (
      <InputWrapper
        inputRef={ref as MutableRefObject<HTMLInputElement>}
        {...InputWrapperProps}
        id={id}
        className={wrapperClassName}
        hasValue={!!props.value}
        innerafter={
          type === "password"
            ? passwordInnerAfter
            : InputWrapperProps.innerafter
        }
      >
        <input
          style={{
            height: height + " !important"
          }}
          {...props}
          type={
            type == "password" ? (showPassword ? "text" : "password") : type
          }
          ref={ref}
          rel="monta-input"
          aria-label={InputWrapperProps.label || placeholder}
        />
      </InputWrapper>
    );
  }
);

TextField.displayName = "TextField";

export default TextField;
